import { newsletterState } from './newsletter.state';
import { newsletterActions } from './newsletter.action';
import { newsletterMutations } from './newsletter.mutation';

export default {
  namespaced: true,
  state: newsletterState,
  getters: {},
  actions: newsletterActions,
  mutations: newsletterMutations,
};
